import { FileText, UserCheck, ClipboardCheck, Shield, CheckCircle } from 'lucide-react';

const Membership = () => {
    const steps = [
        {
            icon: <FileText className="w-8 h-8" />,
            title: 'Step 1: Application Submission',
            description: 'Fill out the membership application form with accurate personal and contact information. Forms are available at our branches or can be downloaded from our office.'
        },
        {
            icon: <ClipboardCheck className="w-8 h-8" />,
            title: 'Step 2: Documentation',
            description: 'Submit required KYC documents including: Aadhaar Card, PAN Card, address proof, and passport-size photographs. All documents must be self-attested.'
        },
        {
            icon: <Shield className="w-8 h-8" />,
            title: 'Step 3: Verification & KYC',
            description: 'Our team will verify your submitted documents and conduct KYC compliance checks as per regulatory requirements. This process typically takes 2-3 business days.'
        },
        {
            icon: <UserCheck className="w-8 h-8" />,
            title: 'Step 4: Approval',
            description: 'Once verified, your membership will be approved by the board. You will receive a membership certificate and unique member ID.'
        },
        {
            icon: <CheckCircle className="w-8 h-8" />,
            title: 'Step 5: Activate Your Account',
            description: 'Make your first deposit to activate your savings account and start enjoying member benefits, including access to all deposit and loan products.'
        }
    ];

    return (
        <section id="membership" className="py-16 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Membership Process</h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        Becoming a member is simple and straightforward. Follow these five steps to join our community.
                    </p>
                </div>

                <div className="space-y-6 max-w-4xl mx-auto">
                    {steps.map((step, index) => (
                        <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow border border-gray-200">
                            <div className="flex items-start">
                                <div className="text-amber-900 mr-4 flex-shrink-0">
                                    {step.icon}
                                </div>
                                <div>
                                    <h3 className="text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
                                    <p className="text-gray-700 text-sm leading-relaxed">{step.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-12 bg-amber-50 rounded-xl p-8 border border-amber-200 max-w-4xl mx-auto">
                    <h3 className="text-xl font-bold text-gray-900 mb-4">Eligibility Requirements</h3>
                    <ul className="space-y-2 text-gray-700">
                        <li className="flex items-start">
                            <span className="text-amber-950 mr-2 font-bold">•</span>
                            <span className="text-sm">Applicant must be at least 18 years of age</span>
                        </li>
                        <li className="flex items-start">
                            <span className="text-amber-950 mr-2 font-bold">•</span>
                            <span className="text-sm">Valid Aadhaar card and PAN card are mandatory</span>
                        </li>
                        <li className="flex items-start">
                            <span className="text-amber-950 mr-2 font-bold">•</span>
                            <span className="text-sm">Proof of address (utility bill, bank statement, or rental agreement)</span>
                        </li>
                        <li className="flex items-start">
                            <span className="text-amber-950 mr-2 font-bold">•</span>
                            <span className="text-sm">Minimum share capital contribution as specified by the society</span>
                        </li>
                        <li className="flex items-start">
                            <span className="text-amber-950 mr-2 font-bold">•</span>
                            <span className="text-sm">Compliance with KYC norms and co-operative society regulations</span>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default Membership;
